// Source
import * as Instance from "../Instance";
import * as ModelHelperSrc from "../../model/HelperSrc";
import * as ModelTeam from "../../model/custom/Team";

export const createData = (name: string, member: Record<string, unknown> | "", callback: ModelHelperSrc.IapiCallback): void => {
    const data = {
        name,
        member
    };

    Instance.api
        .post<ModelHelperSrc.Iresponse>(
            `/team/create_data`,
            {
                headers: {
                    "Content-Type": "application/json"
                }
            },
            data
        )
        .then((response) => {
            return callback(response.data);
        })
        .catch((error: Error) => {
            return callback(error);
        });
};

export const updateData = (id: number, name: string, member: Record<string, unknown> | "", callback: ModelHelperSrc.IapiCallback): void => {
    const data = {
        id,
        name,
        member
    };

    Instance.api
        .post<ModelHelperSrc.Iresponse>(
            `/team/update_data`,
            {
                headers: {
                    "Content-Type": "application/json"
                }
            },
            data
        )
        .then((response) => {
            return callback(response.data);
        })
        .catch((error: Error) => {
            return callback(error);
        });
};

export const removeData = (id: number, callback: ModelHelperSrc.IapiCallback): void => {
    const data = { id };

    Instance.api
        .post<ModelHelperSrc.Iresponse>(
            "/team/remove_data",
            {
                headers: {
                    "Content-Type": "application/json"
                }
            },
            data
        )
        .then((response) => {
            return callback(response.data);
        })
        .catch((error: Error) => {
            return callback(error);
        });
};

export const validationForm = (callback: ModelHelperSrc.IapiCallback): void => {
    Instance.api
        .get<ModelHelperSrc.Iresponse>("/team/validation_form", {
            headers: {
                "Content-Type": "application/json"
            }
        })
        .then((response) => {
            return callback(response.data);
        })
        .catch((error: Error) => {
            return callback(error);
        });
};

export const dataList = (dataMain: ModelTeam.Idata, sortOrder: string, page: string, callback: ModelHelperSrc.IapiCallback): void => {
    const data = {
        sort_order: sortOrder,
        page: page,
        name: dataMain.name,
        latest_update: dataMain.latest_update,
        latest_update_by_id: dataMain.latest_update_by_id as unknown as string
    } as Record<string, string>;

    const urlParameter = new URLSearchParams(data);

    Instance.api
        .get<ModelHelperSrc.Iresponse>(`/team/data_list?${urlParameter.toString()}`, {
            headers: {
                "Content-Type": "application/json"
            }
        })
        .then((response) => {
            return callback(response.data);
        })
        .catch((error: Error) => {
            return callback(error);
        });
};

export const selectOption = (callback: ModelHelperSrc.IapiCallback): void => {
    Instance.api
        .get<ModelHelperSrc.Iresponse>("/team/select_option", {
            headers: {
                "Content-Type": "application/json"
            }
        })
        .then((response) => {
            return callback(response.data);
        })
        .catch((error: Error) => {
            return callback(error);
        });
};
